/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbShipping_viewer$ref = any;
type PdpSharedBlurbSupportNumber_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_viewer$ref: FragmentReference;
export type PdpRespSidebarBlurbs_viewer = {|
  +isConsultAnExpertDisabled?: ?boolean,
  +$fragmentRefs: PdpSharedBlurbShipping_viewer$ref & PdpSharedBlurbSupportNumber_viewer$ref,
  +$refType: PdpRespSidebarBlurbs_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isConsultAnExpertDisabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "DISABLE_CONSULT_AN_EXPERT",
              "type": "String!"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2d2511a8283ee53791bf50bf755938fd';
module.exports = node;
